module.exports = __webpack_public_path__ + "img/Hill_sPet_logo_white.b8bc0305.png";